import type { ReactNode } from "react";

type ResponsiveTextProps = {
  /** Base/mobile text (always shown by default) */
  base: ReactNode;
  /** Text for sm breakpoint (640px+) */
  sm?: ReactNode;
  /** Text for md breakpoint (768px+) */
  md?: ReactNode;
  /** Text for lg breakpoint (1024px+) */
  lg?: ReactNode;
  /** Text for xl breakpoint (1280px+) */
  xl?: ReactNode;
};

export function ResponsiveText({ base, sm, md, lg, xl }: ResponsiveTextProps) {
  // If no responsive variants, just return the base
  if (!sm && !md && !lg && !xl) return <>{base}</>;

  // Determine where each breakpoint's content should hide
  const baseHideAt = sm ? "sm:hidden" : md ? "md:hidden" : lg ? "lg:hidden" : xl ? "xl:hidden" : "";
  const smHideAt = md ? "md:hidden" : lg ? "lg:hidden" : xl ? "xl:hidden" : "";
  const mdHideAt = lg ? "lg:hidden" : xl ? "xl:hidden" : "";
  const lgHideAt = xl ? "xl:hidden" : "";

  return (
    <>
      {/* Mobile: show base, hide at first defined breakpoint */}
      <span className={baseHideAt}>{base}</span>

      {/* Small: show sm variant if defined */}
      {sm && <span className={`hidden sm:inline ${smHideAt}`}>{sm}</span>}

      {/* Tablet: show md variant if defined */}
      {md && <span className={`hidden md:inline ${mdHideAt}`}>{md}</span>}

      {/* Desktop lg: show lg variant if defined */}
      {lg && <span className={`hidden lg:inline ${lgHideAt}`}>{lg}</span>}

      {/* Desktop xl: show xl variant if defined */}
      {xl && <span className="hidden xl:inline">{xl}</span>}
    </>
  );
}
